module.exports = __webpack_public_path__ + "images/d11dec8981ab7164b28dc6d16def535a.png";